/**
 * @fileOverview Displays a code on the screen that is attached to the mouse
 * or touch being dragged
 */

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { CodeBlock } from './CodeBlock'

class CodeDragger extends Component {
  state = {}

  componentDidMount = () => {
    document.body.addEventListener('mousemove', this.onMouseMove)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove = e => {
    const width = this.props.code.code.length * 8.4 + 40 + 2,
      height = 40 + 2

    this.setState({
      left: e.pageX - width / 2,
      top: e.pageY - height / 2,
    })
    e.stopPropagation()
    e.preventDefault()
  }

  //onMouseUp = () => {
  //  this.props.
  //}

  render = () => {
    const { code } = this.props
    const { left, top } = this.state

    return ReactDOM.createPortal(
      <CodeBlock
        {...code}
        style={{
          left: left,
          top: top,
          position: 'absolute',
          pointerEvents: 'none',
        }}
      />,
      // There's some wierd material ui styling the interfers with last
      // elements, so we're attaching to a container before the last element
      // as a work around
      document.getElementById('root2') || document.body,
    )
  }
}

export default CodeDragger
